export const notSchCon = {
    notify_sch: ['notify.sch.con'],
    mpPageReset: ['mp.pageReset'],
    mpAppReset: ['mp.appReset'],
    notify_sch_con: (pageFilter) => [...notSchCon.notify_sch, pageFilter],
};
